import gql from 'graphql-tag';

export default gql`
  mutation UpdateFacility(
    $id: ID!
    $data: FacilityUpdateInput!
  ) {
    updateFacility(
      id: $id
      data: $data
    ) {
      id
      name
      status
      menus
      pdfs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateFacility.ts